module.exports = __webpack_public_path__ + "static/media/QRcode.e65345d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/QRcode.svg
// module id = 120
// module chunks = 0